/* Actions */
import { types as userTypes } from "./user";
import { types as dashboardTypes } from "./dashboard";
import { types as searchTypes } from "./search";
import { types as audioTypes } from "./audio";
import { types as tracksTypes } from "./tracks";
import { types as channelsTypes } from "./channels";
import { types as homeTypes } from "./home";
import { types as tagTypes } from "./tags";
import { types as adTypes } from "./ads";
import { types as mediumsTypes } from "./mediums";
/* Requests */
import { requests as adRequets } from "./ads";

export default {
  ...userTypes,
  ...dashboardTypes,
  ...searchTypes,
  ...audioTypes,
  ...tracksTypes,
  ...channelsTypes,
  ...homeTypes,
  ...tagTypes,
  ...adTypes,
  ...mediumsTypes,
  ...adTypes
};

export const requests = {
  ...adRequets
}